<template>
  <b-form-group
    label="Cooperado"
    :state="state('selecaoCooperado')"
    invalid-feedback="O campo cooperado é obrigatório"
  >
    <multiselect
      v-model="selecaoCooperado"
      label="name"
      track-by="name"
      :taggable="false"
      :allowEmpty="false"
      :options="cooperadoLkp"
      :disabled="disabledCooperado"
      placeholder="Selecione o cooperado"
      selected-label=""
      select-label=""
      deselect-label=""
      @input="emitirCooperado"
    >
      <span slot="noResult">Nenhum cooperado encontrado</span>
      <span slot="noOptions">Nenhum cooperado disponível</span>
    </multiselect>
  </b-form-group>
</template>

<script>
import Multiselect from "vue-multiselect";
import clienteRuralMixin from "@/tools/mixins/clienteRuralMixin.js";
import { required } from "vuelidate/lib/validators";

export default {
  mixins: [clienteRuralMixin],

  components: {
    Multiselect
  },

  props: {
    submit: {
      type: Boolean,
      default: false
    },
    reset: {
      type: Number,
      default: 0
    },
    value: {
      type: Object,
      default: null
    }
  },

  data() {
    return {
      selecaoCooperado: null,
      disabledCooperado: false,
      cooperadoLkp: [],
      cdPessoa: null,
      sqUsuario: null,
      componentLoaded: false
    };
  },

  computed: {
    quantidadeCooperados() {
      return this.cooperadoLkp.length;
    }
  },

  watch: {
    submit(val) {
      if (!this.componentLoaded) return;

      if (val) {
        this.$v.$touch();
      } else {
        this.$v.$reset();
      }
    },

    reset() {
      this.$v.$reset();

      if (this.cooperadoLkp.length === 1) {
        this.selecaoCooperado = this.cooperadoLkp[0];
      } else {
        this.selecaoCooperado = null;
      }

      this.emitirCooperado();
    },

    value: {
      handler(newVal) {
        if (newVal && this.cooperadoLkp.length > 0) {
          const encontrado = this.cooperadoLkp.find(
            cooperado => cooperado.value === newVal.value
          );

          if (encontrado) {
            this.selecaoCooperado = encontrado;
          }
        } else if (newVal === null && this.selecaoCooperado !== null) {
          this.selecaoCooperado = null;
        }
      },
      immediate: true
    }
  },

  validations: {
    selecaoCooperado: {
      required
    }
  },

  async created() {
    await this.buscarDados();
  },

  methods: {
    async buscarDados() {
      await this.getNomeRazaoUsuario();
      await this.buscarLkpCooperado();

      this.disabledCooperado = this.cooperadoLkp.length === 1;

      await this.verificarCooperado();

      if (this.value && this.cooperadoLkp.length > 0) {
        const encontrado = this.cooperadoLkp.find(
          cooperado => cooperado.value === this.value.value
        );

        if (encontrado) {
          this.selecaoCooperado = encontrado;
        }
      }

      this.emitirCooperado();

      this.componentLoaded = true;
    },

    async getNomeRazaoUsuario() {
      try {
        this.cdPessoa = this.$store.state.me?.cd_pessoa;
        this.sqUsuario = this.$store.state.me?.sq_usuario;
      } catch {
        this.logoutUser();
      }
    },

    async verificarCooperado() {
      if (this.cooperadoLkp.length === 1) {
        this.selecaoCooperado = this.cooperadoLkp[0];
        return;
      }

      if (this.cooperadoLkp.length > 1) {
        const cooperadoEncontrado = this.cooperadoLkp.find(
          cooperado => cooperado.value === this.cdPessoa
        );

        this.selecaoCooperado = cooperadoEncontrado || null;
        return;
      }

      this.selecaoCooperado = null;
    },

    state(param) {
      if (!this.componentLoaded) {
        return null;
      }

      if (this.submit) {
        return !this.$v[param].$invalid;
      }

      return null;
    },

    emitirCooperado() {
      this.$emit("cooperadoSelecionado", this.selecaoCooperado ?? null);
      this.$emit("input", this.selecaoCooperado ?? null);
    }
  }
};
</script>
